import React from "react";
import type { Id, Doc } from "../../../../convex/_generated/dataModel";
import type { NewAppData } from "../types/reference";

interface AppSelectionSectionProps {
  selectedAppId: Id<"apps"> | "new" | null;
  setSelectedAppId: (id: Id<"apps"> | "new" | null) => void;
  allApps: Doc<"apps">[];
  creatingApp: boolean;
  setCreatingApp: (creating: boolean) => void;
  newApp: NewAppData;
  setNewApp: (app: NewAppData) => void;
  onCreateApp: () => void;
}

export function AppSelectionSection({
  selectedAppId,
  setSelectedAppId,
  allApps,
  creatingApp,
  setCreatingApp,
  newApp,
  setNewApp,
  onCreateApp
}: AppSelectionSectionProps) {
  return (
    <div>
      <label htmlFor="app" className="block text-sm font-medium text-gray-700">App / Website</label>
      <div className="flex gap-2 items-center mt-1">
        <select
          id="app"
          value={selectedAppId || ""}
          onChange={e => {
            const val = e.target.value;
            if (val === "new") setCreatingApp(true);
            setSelectedAppId(val === "" ? null : (val as Id<"apps"> | "new"));
          }}
          className="select select-bordered w-full"
        >
          <option value="">Select an app (optional)...</option>
          {allApps.map((app: Doc<"apps">) => (
            <option key={app._id} value={app._id}>{app.name}</option>
          ))}
          <option value="new">+ Create new app</option>
        </select>
      </div>
      
      {creatingApp && (
        <div className="card bg-base-200 mt-2">
          <div className="card-body p-3 space-y-2">
            <div>
              <input
                type="text"
                placeholder="App name*"
                value={newApp.name}
                onChange={e => setNewApp({ ...newApp, name: e.target.value })}
                required
                className="input input-bordered input-sm w-full"
              />
            </div>
            <div>
              <input
                type="url"
                placeholder="App URL"
                value={newApp.url}
                onChange={e => setNewApp({ ...newApp, url: e.target.value })}
                className="input input-bordered input-sm w-full"
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Category (e.g. Productivity, Social)"
                value={newApp.category}
                onChange={e => setNewApp({ ...newApp, category: e.target.value })}
                className="input input-bordered input-sm w-full"
              />
            </div>
            <div>
              <textarea
                placeholder="Description"
                value={newApp.description}
                onChange={e => setNewApp({ ...newApp, description: e.target.value })}
                className="textarea textarea-bordered textarea-sm w-full"
                rows={2}
              />
            </div>
            <div className="flex gap-2">
              <button 
                type="button" 
                onClick={onCreateApp} 
                className="btn btn-primary btn-sm"
              >
                Create
              </button>
              <button 
                type="button" 
                onClick={() => setCreatingApp(false)} 
                className="btn btn-neutral btn-sm"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 